<p-message severity="{{messageService.severity}}" text="{{ ((messageService.message)?messageService.message:'AUTHENTICATION.IN_PROGRESS') | translate }}" styleClass="p-mr-2"></p-message>
